const environment = {
    //API: "https://customer_uat.bigpandasuite.com/api",
    //API: "http://local.sanborns/api",
    API: "https://agent.sanborns.com/api",
    SERVER: "https://agent.sanborns.com/"
  };
  export default environment;